import React from 'react';
import RestNetworkEditor from './RestNetworkEditor.jsx';
import CustomNetworkEditor from './CustomNetworkEditor.jsx';

function createEditor( network, props ) {
  if ( network == null ) {
    return null;
  }
  props = props || {};
  props.network = network;
  switch ( network.type ) {
    case 'rest': return <RestNetworkEditor {...props} />
    case 'custom': return <CustomNetworkEditor {...props} />
    // case 'iothub': return <IotHubNetworkEditor {...props} />
    default: return null
  }
}

module.exports = {
  createEditor
}
